import React from "react";
//import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import config from '../config';

const getContent = ({ lang, setStateLang, curPage, setCurPage }) => {
    return (
        <div className='container page-body'>
          <h2 className="p-4">{ config.pg_content.nav["aboutus"][lang] }</h2>
          <div className="main-content dcont border border-light rounded shadow p-3" id="ab1" dangerouslySetInnerHTML={{ __html: config.pg_content.about.ab1[lang] }}></div>
        </div>
    );
}

export default getContent;